import { ContentIntro } from './content/intro';
import { InternServiceLink } from './intern/service-link';
import { LinkInternalLink } from './link/internal-link';

/**
 * Model definition for service-link-list
 */
export interface ServiceLinkList {
  __contentType: 'service-link-list';
  id: string;
  name?: string;
  intro?: ContentIntro;
  data?: { [key: string]: unknown };
  links: InternServiceLink[];
  dividerLink?: LinkInternalLink;
}

export function isServiceLinkList(obj: { __contentType?: string }): obj is ServiceLinkList {
  return obj.__contentType === 'service-link-list';
}
